import React from 'react'
import PropTypes from 'prop-types'

import BasePureComponent from 'utils/BasePureComponent'

import './style.scss'


const _renderErrors = (errors) => {
  const _renderError = (error, idx) => <li key={idx}>{error}</li>
  const hasErrors =  errors.length > 0

  return hasErrors ? (
    <ul className="errors-list">
      {errors.map(_renderError)}
    </ul>
  ) : null
}

const _renderIcon = (iconName) => {
  return iconName ? (
    <span className="input-group-addon material-icons">{iconName}</span>
  ) : null
}

const _renderLabel = (label, inputId) => ( !!label ? <label htmlFor={inputId}>{label}</label> : null )

const _renderErrorIcon = () => <span className="error-icon material-icons">close</span>


export default class Input extends BasePureComponent {
  render() {
    // extract invalid props for HTML <input />
    const {errors, id, label, icon, size, iconAlign, className: inputClass, ...inputProps} = this.props
    const hasErrors =  errors.length > 0

    const hasIconClass = !!icon ? 'has-icon' : ''
    const iconAlignClass = `icon-${iconAlign}`
    const errorClass = hasErrors ? 'has-error' : ''
    const sizeClass = size || ''
    const inputId = id || `id_${inputProps.name}`

    return (
      <div className={`Input ${errorClass} ${sizeClass}`}>
        {_renderLabel(label, inputId)}
        <div className={`input-group ${hasIconClass} ${iconAlignClass}`}>
          <input
            id={inputId}
            ref={(input) => this.input = input}
            className={`form-control ${inputClass}`}
            {...inputProps}
          />
          {_renderIcon(icon)}
          { hasErrors ? _renderErrorIcon() : null }
        </div>
        {_renderErrors(errors)}
      </div>
    )
  }
}

Input.defaultProps = {
  errors: [],
  size: null,
  name: null,
  label: null,
  id: null,
  className: '',
  icon: null,
  iconAlign: 'left'
}

Input.propTypes = {
  icon: PropTypes.string,
  iconAlign: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
  size: PropTypes.oneOf(['big', null]),
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/Input/index.js